<template>
  <div class="bb-tag-cell">
    <TagsVendor :limitCount="limitCount"
                :table="true"
                :fixedPopup="true"
                :tags="row.vendorTags"/>
  </div>
</template>

<script>
import TagsVendor from '@/components/Dissemination/Sales/CRM/ContactCard/ContactServiceProvider/TagsVendor'
export default {
  name: 'TagCell',
  props: ['row', 'column', 'index', 'hover'],
  components: {
    TagsVendor
  },
  data () {
    return {
      limitCount: 0
    }
  }
}
</script>

<style lang="scss" scoped>
  .bb-tag-cell {
  }
</style>



// WEBPACK FOOTER //
// src/components/Main/BBTable/TagCell/TagCell.vue